// this file is automatically generated by the scripts/git-version.js script
export const versions = {
  version: '0.0.0',
  revision: 'eed94bcca057aa239421e92e910bda5c8606cefe',
  branch: 'sprint-28',
  date: '1792767502128'
};
